import { render, staticRenderFns } from "./Ppt.vue?vue&type=template&id=327e42cc"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('327e42cc')) {
      api.createRecord('327e42cc', component.options)
    } else {
      api.reload('327e42cc', component.options)
    }
    module.hot.accept("./Ppt.vue?vue&type=template&id=327e42cc", function () {
      api.rerender('327e42cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/fileExtensions/Ppt.vue"
export default component.exports